namespace $ {
	export let $mol_array_shuffle_sync = $mol_wire_sync( $mol_array_shuffle ) as typeof $mol_array_shuffle
}
